import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
import imports from './imports'
import agentIds from './agent-ids'
import rtdf from './rtdf'
import alto from './alto'
/**
* @see \App\Http\Controllers\CompaniesAtlasController::index
* @see app/Http/Controllers/CompaniesAtlasController.php:19
* @route '/companies/{company}/atlas'
*/
export const index = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/atlas',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CompaniesAtlasController::index
* @see app/Http/Controllers/CompaniesAtlasController.php:19
* @route '/companies/{company}/atlas'
*/
index.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return index.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CompaniesAtlasController::index
* @see app/Http/Controllers/CompaniesAtlasController.php:19
* @route '/companies/{company}/atlas'
*/
index.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CompaniesAtlasController::index
* @see app/Http/Controllers/CompaniesAtlasController.php:19
* @route '/companies/{company}/atlas'
*/
index.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

const atlas = {
    index: Object.assign(index, index),
    imports: Object.assign(imports, imports),
    agentIds: Object.assign(agentIds, agentIds),
    rtdf: Object.assign(rtdf, rtdf),
    alto: Object.assign(alto, alto),
}

export default atlas